import { SortDescriptor } from "react-aria-components";

import { USER_IDP_GROUPS_COLUMN_ID } from "../constants";
import { IdpGroupWithMapped } from "../types";

export const sortGroups = (items: IdpGroupWithMapped[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as USER_IDP_GROUPS_COLUMN_ID) {
      case USER_IDP_GROUPS_COLUMN_ID.NAME:
        valueA = a.name;
        valueB = b.name;
        break;
      case USER_IDP_GROUPS_COLUMN_ID.STATUS:
        valueA = a.mapped?.status;
        valueB = b.mapped?.status;
        break;
      case USER_IDP_GROUPS_COLUMN_ID.DESCRIPTION:
        return 0;
      default:
        return 0;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });
};
